import React, { PureComponent } from "react";
import styled from 'styled-components';

import TeamRolesSelector from './selector';
import { teamPlayerRowsPerPage } from '../../constants';

import PaginationArrowIcon from '../../../containers/assets/icon-teams-roles-pagination-right.svg';

const PaginationWrapper = styled.div`
  padding: 11px 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

const RowsSelectorWrapper = styled.div`
  display: flex;
  gap: 25px;
`;

const RowsCount = styled.div`
  margin-left: 20px;
`;

const PageArrows = styled.div`
  display: flex;
  gap: 20px;
  margin-left: 20px;
`;

const PageArrow = styled.button`
  width: 27px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: .4;
  pointer-events: none;

  ${p => p.prev && `
    transform: rotate(180deg);
  `}

  ${p => p.active && `{
    opacity: 1;
    pointer-events: auto;
  }`}}
`;

class TeamsRolesPagination extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      typing: false,
      typingTimeout: 0
    };
  }

  render() {
    const {
      rowsPerPage,
      handleRowsPerPageChange,
      rowsTotal,
      activePrevPage,
      activeNextPage,
      page,
      handlePageChange
    } = this.props;

    const rowStart = (page - 1) * Number(rowsPerPage) + 1;
    let rowsEnd = rowStart + Number(rowsPerPage) - 1;
    if (rowsEnd > rowsTotal) {
      rowsEnd = rowsTotal;
    }

    return (
      <PaginationWrapper>
        <RowsSelectorWrapper>
          <span>Rows per page:</span>
          <TeamRolesSelector
            options={teamPlayerRowsPerPage}
            selectedOptionId={rowsPerPage}
            size="small"
            onSelectorChange={handleRowsPerPageChange}
          />
        </RowsSelectorWrapper>
        <RowsCount>
          {rowStart}-{rowsEnd} of {rowsTotal}
        </RowsCount>
        <PageArrows>
          <PageArrow prev active={activePrevPage} onClick={() => handlePageChange(page - 1)}>
            <img src={PaginationArrowIcon} alt="Prev" />
          </PageArrow>
          <PageArrow active={activeNextPage} onClick={() => handlePageChange(page + 1)}>
            <img src={PaginationArrowIcon} alt="Next" />
          </PageArrow>
        </PageArrows>
      </PaginationWrapper>
    );
  }
}

export default TeamsRolesPagination;



// WEBPACK FOOTER //
// ./src/instructor/components/teams-roles/pagination.js